import React, { Component } from 'react';
import { Row, Col, Table } from 'antd';
import '../index.scss'

class index extends Component {
    render() {
        const columns = [{
            dataIndex: 'name',
            key: 'name',
            render: (text) => {
                return <div style={{ padding: "10px", textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: text }}></div>
            }
        }, {
            dataIndex: 'desc',
            key: 'desc',
            render: (text) => {
                return <div style={{ padding: "10px", textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: text }}></div>
            }
        }];
        return (
            <div className="derformanceDes">
                <div className='title'>1.3.1 Breakdown Statistics Data 统计数据归集依据</div>
                <div className='text_center'>
                    <div>Average Industry Performance Data Source: China Hotel Industry Study 2021 & Statistical Communique of The People's Republic of China on the 2022 Q1 Star Hotel</div>
                    <div>行业数据来源 《2021年中国饭店业统计（2020财政年度）》（浩华管理顾问公司）和《2022年第一季度全国星级饭店统计公报》（中华人民共和国文化和旅游部市场管理司）</div>
                </div>
                <Row className='table_title'>
                    <Col className='align' span={24}>Average Area Performance Data  区域平均数据</Col>
                </Row>
                <Row gutter={56}>
                    <Col span={12}>
                        <div className='table_border'>
                            <Row>
                                <Col span={24}>Southeastern & Southern China 东南华南</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>海南龙沐湾温德姆至尊豪廷大酒店</Col>
                                <Col span={12}>WGPR Hainan Longmu Bay </Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>文昌温德姆至尊豪廷大酒店</Col>
                                <Col span={12}>WGPR Wenchang </Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>梅州昌盛豪生大酒店</Col>
                                <Col span={12}>HOJO Changsheng Plaza Meizhou</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>漳州明发温德姆至尊豪廷大酒店</Col>
                                <Col span={12}>WGPR Mingfa Zhangzhou</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>厦门集美湖豪生大酒店</Col>
                                <Col span={12}>HOJO Jimei Lake Plaza Xiamen</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>海口星海湾豪生大酒店</Col>
                                <Col span={12}>HOJO New Port Resort Haikou</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>厦门禹洲温德姆至尊豪廷大酒店</Col>
                                <Col span={12}>WGPR Yuzhou Xiamen</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>广西长融豪宜酒店 </Col>
                                <Col span={12}>HOJO Life Changrong Guangxi</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>安顺豪生温泉度假酒店</Col>
                                <Col span={12}>HOJO Hot Spring Resort Anshun</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>鹰潭沁庐豪生大酒店</Col>
                                <Col span={12}>HOJO Qinlu Plaza Yingtan</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>广州桃花江豪生酒店</Col>
                                <Col span={12}>HOJO Riverview Hotel Guangzhou</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>澄海国瑞豪生酒店 </Col>
                                <Col span={12}>HOJO Glory Hotel Chenghai</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>贵州天怡豪生大酒店</Col>
                                <Col span={12}>HOJO Plaza Guiyang</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>惠州双月湾檀悦豪生温泉度假酒店</Col>
                                <Col span={12}>HOJO Shuangyue Bay Huizhou</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>三亚国光豪生度假酒店</Col>
                                <Col span={12}>HOJO Resort Sanya Bay</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>南宁会展豪生大酒店</Col>
                                <Col span={12}>HOJO CAEXPO Plaza NanNing</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>余庆第三地豪宜酒店</Col>
                                <Col span={12}>HOJO Life Parkview Yuqing</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>贵州瑞茂温德姆至尊豪廷大酒店</Col>
                                <Col span={12}>WGPR Ruimao Guizhou</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>厦门海旅温德姆至尊酒店</Col>
                                <Col span={12}>WG Xiamen Haicang</Col>
                            </Row>
                            <Row className='bg_w' style={{ border: 'none' }}>
                                <Col span={12} className='left'>贵州群升豪生大酒店</Col>
                                <Col span={12}>HOJO Qunsheng Plaza Guizhou</Col>
                            </Row>
                        </div>
                    </Col>
                    <Col span={12}>
                        <div className='table_border'>
                            <Row>
                                <Col span={24}>Northern & Central China 华北华中</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>长沙芙蓉国温德姆至尊豪廷大酒店</Col>
                                <Col span={12}>WGPR Furongguo Changsha </Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>长沙湘江豪生酒店</Col>
                                <Col span={12}>HOJO Yacht Club Hotel Changsha</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>大连百年汇豪生酒店</Col>
                                <Col span={12}>HOJO Parkland Hotel Dalian</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>威海香海豪生度假酒店 </Col>
                                <Col span={12}>HOJO Dream Sea Resort Weihai</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>邵阳湘林温德姆至尊豪廷大酒店</Col>
                                <Col span={12}>WGPR Xianglin Shaoyang </Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>郴州温德姆至尊豪廷大酒店</Col>
                                <Col span={12}>WGPR Chenzhou </Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>江城明珠豪生大酒店</Col>
                                <Col span={12}>HOJO Pearl Plaza Wuhan</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>山东临沂翔宇豪生大酒店</Col>
                                <Col span={12}>HOJO Xiangyu Plaza Linyi</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>营口五矿豪生大酒店</Col>
                                <Col span={12}>HOJO Minmetals Plaza Yingkou</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>沈阳锦联豪生酒店</Col>
                                <Col span={12}>HOJO Jinlian Business Club Shenyang</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>西安金花豪生国际大酒店</Col>
                                <Col span={12}>HOJO Ginwa Plaza Xi'an</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>青岛康大豪生大酒店</Col>
                                <Col span={12}>HOJO Plaza Kangda Qingda</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>山东临沂翔宇豪生大酒店</Col>
                                <Col span={12}>HOJO Xiangyu Plaza Linyi</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>鄂尔多斯博源豪生大酒店</Col>
                                <Col span={12}>HOJO Parkview Plaza Erdos</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>北京宝辰饭店</Col>
                                <Col span={12}>HOJO Paragon Hotel Beijing</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>乌兰察布多蒙德豪生大酒店</Col>
                                <Col span={12}>HOJO Plaza Wulanchabu</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>长沙华晨豪生大酒店</Col>
                                <Col span={12}>HOJO Huachen Plaza Changsha</Col>
                            </Row>
                            <Row className='bg_w' style={{ border: 'none' }}>
                                <Col span={12} className='left'>株洲高科豪宜酒店</Col>
                                <Col span={12}>HOJO Geckor Zhuzhou</Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
                <Row gutter={56} style={{ marginTop: 40 }}>
                    <Col span={12}>
                        <div className='table_border'>
                            <Row>
                                <Col span={24}>Jiangsu, Zhejiang, Shanghai & Anhui 江浙沪皖</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>上海虹桥金古源豪生大酒店</Col>
                                <Col span={12}>HOJO Hongqiao Airport Hotel SH</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>南京卧龙湖温德姆至尊豪廷度假酒店</Col>
                                <Col span={12}>WGPR Lake Crouching Dragon Resort Nanjing</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>宁波华侨豪生温德姆至尊豪廷大酒店</Col>
                                <Col span={12}>WGPR Ningbo</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>杭州温德姆至尊豪廷大酒店</Col>
                                <Col span={12}>WGPR Hangzhou</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>蚌埠南山豪生大酒店</Col>
                                <Col span={12}>HOJO Nanshan Plaza Bengbu</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>阜阳宝龙温德姆至尊豪廷大酒店</Col>
                                <Col span={12}>WGPR Baolong Fuyang</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>安吉凯承温德姆至尊豪廷大酒店</Col>
                                <Col span={12}>WGPR Kaicheng Anji</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>凯迪温德姆至尊豪廷大酒店</Col>
                                <Col span={12}>WGPR Kaidi</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>合肥两淮豪生大酒店</Col>
                                <Col span={12}>HOJO Tech Center Plaza Hefei</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>宁波逸东豪生大酒店</Col>
                                <Col span={12}>HOJO IFC Plaza Ningbo</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>江阴长晟温德姆至尊豪廷大酒店</Col>
                                <Col span={12}>WGPR Changsheng Jiangyin</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>上海兴荣温德姆酒店</Col>
                                <Col span={12}>Wyndham Bund East SH</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>阜阳天筑豪生大酒店</Col>
                                <Col span={12}>HOJO Tianzhu Plaza Fuyang</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>上海兴荣温德姆至尊豪廷酒店 </Col>
                                <Col span={12}>WGPR Oriental SH</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>宁波卓远豪宜酒店</Col>
                                <Col span={12}>HOJO Life Zhuoyuan Ningbo</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>上海临港豪生大酒店 </Col>
                                <Col span={12}>HOJO Plaza Lingang SH</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>庐山嘉豪淮海国际豪生酒店</Col>
                                <Col span={12}>HOJO Huaihai Resort Lushan</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>天目湖豪生大酒店</Col>
                                <Col span={12}>HOJO Tian Mu Lake Plaza Liyang</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>黄山新华联豪生大酒店</Col>
                                <Col span={12}>HOJO Macrolink Plaza Huangshan</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>常州凯纳豪生大酒店</Col>
                                <Col span={12}>HOJO Kaina Plaza Changzhou</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>苏州晋合豪生行政公寓</Col>
                                <Col span={12}>HOJO Jinhope Suzhou </Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>上海财大豪生大酒店</Col>
                                <Col span={12}>HOJO Caida Plaza SH</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>绍兴中金豪生酒店</Col>
                                <Col span={12}>HOJO Business Club Hotel Shaoxing</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>上海嘉豪淮海国际豪生酒店</Col>
                                <Col span={12}>HOJO Huaihai Hotel SH</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>宁波石浦豪生大酒店</Col>
                                <Col span={12}>HOJO Shipu Plaza Ningbo</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>宁波华侨豪生大酒店</Col>
                                <Col span={12}>HOJO Plaza Ningbo</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>宁波阳光豪生大酒店</Col>
                                <Col span={12}>HOJO Sunshine Plaza Ningbo</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>诸暨同方豪生大酒店</Col>
                                <Col span={12}>HOJO Tongfang Plaza Zhuji</Col>
                            </Row>
                            <Row className='bg_w' style={{ border: 'none' }}>
                                <Col span={12} className='left'>上海丽昂豪生大酒店</Col>
                                <Col span={12}>HOJO Leonora Plaza Shanghai</Col>
                            </Row>
                        </div>
                    </Col>
                    <Col span={12}>
                        <div className='table_border'>
                            <Row>
                                <Col span={24}>Southwestern China 西南</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>成都山景豪宜酒店</Col>
                                <Col span={12}>HOJO Life Mountain View CD </Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>重庆秀山豪生广场国际酒店 </Col>
                                <Col span={12}>HOJO Xiushan Plaza CQ</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>重庆渝融豪生酒店</Col>
                                <Col span={12}>HOJO Yurong Hotel CQ</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>丽江金林豪生大酒店</Col>
                                <Col span={12}>HOJO Jinling Plaza Lijiang</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>重庆普惠豪生大酒店</Col>
                                <Col span={12}>HOJO Puhui Plaza CQ</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>重庆锦怡豪生酒店</Col>
                                <Col span={12}>HOJO Jinyi Hotel CQ</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>资阳鼎晟泓府豪生大酒店</Col>
                                <Col span={12}>HOJO New District Plaza Ziyang</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>昆明南亚风情园豪生大酒店</Col>
                                <Col span={12}>HOJO Tropical Garden Plaza Kunming</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>成都天之府温德姆至尊豪廷大酒店</Col>
                                <Col span={12}>WGPR Palace CD</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>成都雅居乐豪生大酒店</Col>
                                <Col span={12}>HOJO Agile Plaza CD</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>成都高新豪生大酒店</Col>
                                <Col span={12}>HOJO Hi-Tech Plaza CD</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>重庆华宇温德姆至尊豪廷大酒店</Col>
                                <Col span={12}>WGPR Huayu CQ</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>昆明七彩云南温德姆至尊豪廷大酒店</Col>
                                <Col span={12}>WGPR Colorful Yunnan Kunming</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>成都青城豪生国际酒店</Col>
                                <Col span={12}>HOJO Conference Resort CD</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>重庆天喜豪生大酒店 </Col>
                                <Col span={12}>HOJO Tianxi Plaza Chongqing</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>昆明花之城豪生酒店</Col>
                                <Col span={12}>HOJO City of Flower Hotel Kunming </Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>重庆珠江豪生大酒店 </Col>
                                <Col span={12}>HOJO Zhujiang Plaza ChongQing</Col>
                            </Row>
                            <Row className='bg_w'>
                                <Col span={12} className='left'>成都尊悦豪生酒店</Col>
                                <Col span={12}>HOJO Zunyue Hotel CD</Col>
                            </Row>
                            <Row className='bg_w' style={{ border: 'none' }}>
                                <Col span={12} className='left'>九寨沟天源豪生度假酒店</Col>
                                <Col span={12}>HOJO Tianyuan Resort Jiuzhaigou</Col>
                            </Row>
                        </div>
                    </Col>
                </Row>

                <div className='title_2'>1.3.2 Revenue Range (RMB) 收入区间 （单位：元）</div>
                <div className='table_border table7_1_1' style={{ width: 500 }}>
                    <Table columns={columns}
                        dataSource={[{
                            name: "<10 Million <1000万",
                            desc: "55-65 Million 5500-6500万",
                        }, {
                            name: "10-25 Million 1000-2500万",
                            desc: "65-80 Million 6500-8000万",
                        }, {
                            name: "25-35 Million 2500-3500万",
                            desc: "80-100 Million 8000万-1亿",
                        }, {
                            name: "35-45 Million 3500-4500万",
                            desc: ">100 Million 1亿以上",
                        }, {
                            name: "45-55 Million 4500-5500万",
                            desc: "",
                        }]}
                        pagination={false}
                        showHeader={false}
                        size="middle"
                        bordered
                        className="content"
                    />
                </div>

                <div className='title_2'>1.3.3 Definition of Terms 术语解释</div>
                <div className='table_border'>
                    <Row className='definition_row_top'>
                        <Col span={7} className='left'></Col>
                        <Col span={6} className='left'>
                            <Row className='definition_title'>Average Area Performance Data<br />区域平均数据</Row>
                            <Row className='definition_title' style={{ border: 'none' }}>放置区域名称</Row>
                        </Col>
                        <Col span={6} className='left'>
                            <Row className='definition_title'>Revenue Range<br />收入区间</Row>
                            <Row className='definition_title' style={{ border: 'none' }}>放置收入区间名称</Row>
                        </Col>
                        <Col className='definition_title' span={5}>Hotel Performance Data<br />本酒店数据</Col>
                    </Row>
                    <Row className='definition_bg_w'>
                        <Col span={7} className='left'>Efficiency Per Total Room Area SQM 客房可售总面积坪效</Col>
                        <Col span={6} className='left'>  = 区域内 BP 18.0 Budget/Forecast/Actual 客房收入 总和/(区域内 BP 17.1 客房总面积 总和 * 当年天数)</Col>
                        <Col span={6} className='left'>  = 区间内 BP 18.0 Budget/Forecast/Actual 客房收入 总和/(区间内 BP 17.1 客房总面积 总和 * 当年天数)</Col>
                        <Col span={5}>  = BP 18.0 Budget/Forecast/Actual 客房收入/(BP 17.1 客房总面积 * 当年天数)</Col>
                    </Row>
                    <Row className='definition_bg_w'>
                        <Col span={7} className='left'>Total Conference Space SQM 会议室可售总面积</Col>
                        <Col span={6} className='left'>  = 区域内酒店 (BP 12.0 Budget/Forecast/Actual 宴会 Revenue + BP 12.0 Budget/Forecast/Actual 会议场地设施收入 Revenue) 总和/区域内酒店 (BP 17.1 会议室总面积 * 当年天数) 总和</Col>
                        <Col span={6} className='left'>  = 区间内酒店 (BP 12.0 Budget/Forecast/Actual 宴会 Revenue + BP 12.0 Budget/Forecast/Actual 会议场地设施收入 Revenue) 总和/区间内酒店(BP 17.1 会议室总面积 * 当年天数) 总和</Col>
                        <Col span={5}>  = (BP 12.0 Budget/Forecast/Actual 宴会 Revenue + BP 12.0 Budget/Forecast/Actual 会议场地设施收入 Revenue)/(BP 17.1 会议室总面积 * 当年天数) 总和</Col>
                    </Row>
                    <Row className='definition_bg_w'>
                        <Col span={7} className='left'>Efficiency Per Seat No. of All Day Dinning 全日餐厅位数坪效</Col>
                        <Col span={6} className='left'>  = 区域内 BP 12.0 Cafe Budget/Forecast/Actual Revenue 总和/(区域内 BP 17.1 全日餐厅位数 总和 * 当年天数)</Col>
                        <Col span={6} className='left'>  = 区间内 BP 12.0 Cafe Budget/Forecast/Actual Revenue 总和/(区域内 BP 17.1 全日餐厅位数 总和 * 当年天数)</Col>
                        <Col span={5}>  = BP 12.0 Cafe Budget/Forecast/Actual Revenue/BP 17.1 全日餐厅位数 * 当年天数</Col>
                    </Row>
                    <Row className='definition_bg_w'>
                        <Col span={7} className='left'>Efficiency Per All Day Dinning Space SQM 全日餐厅面积坪效</Col>
                        <Col span={6} className='left'>  = 区域内 BP 12.0 Cafe Budget/Forecast/Actual Revenue 总和/(区域内 BP 17.1 全日餐厅面积 总和 * 当年天数)</Col>
                        <Col span={6} className='left'>  = 区间内 BP 12.0 Cafe Budget/Forecast/Actual Revenue 总和/(区域内 BP 17.1 全日餐厅面积 总和 * 当年天数)</Col>
                        <Col span={5}>  = BP 12.0 Cafe Budget/Forecast/Actual Revenue/BP 17.1 全日餐厅面积 * 当年天数</Col>
                    </Row>
                    <Row className='definition_bg_w'>
                        <Col span={7} className='left'>Efficiency Per Seat No. of Chinese Restaurant 中餐大厅位数坪效</Col>
                        <Col span={6} className='left'>  = 区域内 BP 12.0 Chinese Resataurant Budget/Forecast/Actual Revenue 总和/(区域内 BP 17.1 中餐大厅位数 总和 * 当年天数)</Col>
                        <Col span={6} className='left'>  = 区间内 BP 12.0 Chinese Resataurant Budget/Forecast/Actual Revenue 总和/(区间内 BP 17.1 中餐大厅位数 总和 * 当年天数)</Col>
                        <Col span={5}>  = BP 12.0 Chinese Resataurant Budget/Forecast/Actual Revenue/BP 17.1 中餐大厅位数 * 当年天数</Col>
                    </Row>
                    <Row className='definition_bg_w'>
                        <Col span={7} className='left'>Efficiency Per Chinese Restaurant Space SQM 中餐厅面积坪效</Col>
                        <Col span={6} className='left'>  = 区域内 BP 12.0 Chinese Resataurant Budget/Forecast/Actual Revenue 总和/(区域内 BP 17.1 中餐厅面积 总和 * 当年天数)</Col>
                        <Col span={6} className='left'>  = 区间内 BP 12.0 Chinese Resataurant Budget/Forecast/Actual Revenue 总和/(区间内 BP 17.1 中餐厅面积 总和 * 当年天数)</Col>
                        <Col span={5}>  = BP 12.0 Chinese Resataurant Budget/Forecast/Actual Revenue/BP 17.1 中餐厅面积 * 当年天数</Col>
                    </Row>
                    <Row className='definition_bg_w'>
                        <Col span={7} className='left'>Efficiency Per Seat No. of Lounge/Bar 大堂吧/酒吧餐位数坪效</Col>
                        <Col span={6} className='left'>   = 区域内 BP 12.0 Lobby Bar Budget/Forecast/Actual Revenue 总和/(区域内 BP 17.1 大堂吧/酒吧餐位数 总和 * 当年天数)</Col>
                        <Col span={6} className='left'>  = 区间内 BP 12.0 Lobby Bar Budget/Forecast/Actual Revenue 总和/(区间内 BP 17.1 大堂吧/酒吧餐位数 总和 * 当年天数)</Col>
                        <Col span={5}>  = BP 12.0 Lobby Bar Budget/Forecast/Actual Revenue/BP 17.1 大堂吧/酒吧餐位数 * 当年天数</Col>
                    </Row>
                    <Row className='definition_bg_w'>
                        <Col span={7} className='left'>Efficiency Per Lounge/Bar Space SQM 大堂吧面积坪效</Col>
                        <Col span={6} className='left'>  = 区域内 BP 12.0 Lobby Bar Budget/Forecast/Actual Revenue 总和/(区域内 BP 17.1 大堂吧/酒吧面积 总和 * 当年天数)</Col>
                        <Col span={6} className='left'>  = 区间内 BP 12.0 Lobby Bar Budget/Forecast/Actual Revenue 总和/(区间内 BP 17.1 大堂吧/酒吧面积 总和 * 当年天数)</Col>
                        <Col span={5}>  = BP 12.0 Lobby Bar Budget/Forecast/Actual Revenue/BP 17.1 大堂吧/酒吧面积 * 当年天数</Col>
                    </Row>
                    <Row className='definition_bg_w'>
                        <Col span={7} className='left'>Efficiency Per Seat No. of Special Restaurant 特色餐厅餐位数坪效</Col>
                        <Col span={6} className='left'>  = 区域内 BP 12.0 Specia Restaurant Budget/Forecast/Actual Revenue 总和/(区域内 BP 17.1 特色餐厅餐位数 总和 * 当年天数)</Col>
                        <Col span={6} className='left'>  = 区间内 BP 12.0 Specia Restaurant Budget/Forecast/Actual Revenue 总和/(区间内 BP 17.1 特色餐厅餐位数 总和 * 当年天数)</Col>
                        <Col span={5}>  = BP 12.0 Specia Restaurant Budget/Forecast/Actual Revenue/BP 17.1 特色餐厅餐位数 * 当年天数</Col>
                    </Row>
                    <Row className='definition_bg_w'>
                        <Col span={7} className='left'>Efficiency Per Spacial Restaurant Space SQM 特色餐厅面积坪效</Col>
                        <Col span={6} className='left'>  = 区域内 BP 12.0 Specia Restaurant Budget/Forecast/Actual Revenue 总和/(区域内 BP 17.1 特色餐厅面积 总和 * 当年天数)</Col>
                        <Col span={6} className='left'>  = 区间内 BP 12.0 Specia Restaurant Budget/Forecast/Actual Revenue 总和/(区间内 BP 17.1 特色餐厅面积 总和 * 当年天数)</Col>
                        <Col span={5}>  = BP 12.0 Specia Restaurant Budget/Forecast/Actual Revenue/BP 17.1 特色餐厅面积 * 当年天数</Col>
                    </Row>
                    <Row className='definition_bg_w'>
                        <Col span={7} className='left'>Efficiency Per Seat No. of Other Outlets 其他餐厅餐位数坪效</Col>
                        <Col span={6} className='left'>  = 区域内 BP 12.0 Other Outlets Budget/Forecast/Actual Revenue 总和/(区域内 BP 17.1 其他餐厅A+B餐位数 总和 * 当年天数)</Col>
                        <Col span={6} className='left'>  = 区间内 BP 12.0 Other Outlets Budget/Forecast/Actual Revenue 总和/(区间内 BP 17.1 其他餐厅A+B餐位数 总和 * 当年天数)</Col>
                        <Col span={5}>  = BP 12.0 Other Outlets Budget/Forecast/Actual Revenue/BP 17.1 特色餐厅餐位数 * 当年天数</Col>
                    </Row>
                    <Row className='definition_bg_w'>
                        <Col span={7} className='left'>Efficiency Per Other Outlets Space SQM 其他餐厅面积坪效</Col>
                        <Col span={6} className='left'>    = 区域内 BP 12.0 Other Outlets Budget/Forecast/Actual Revenue 总和/(区域内 BP 17.1 其他餐厅A+B面积 总和 * 当年天数)</Col>
                        <Col span={6} className='left'>    = 区间内 BP 12.0 Other Outlets Budget/Forecast/Actual Revenue 总和/(区间内 BP 17.1 其他餐厅A+B面积 总和 * 当年天数)</Col>
                        <Col span={5}>    = BP 12.0 Other Outlets Budget/Forecast/Actual Revenue/BP 17.1 其他餐厅A+B面积 * 当年天数</Col>
                    </Row>
                    <Row className='definition_bg_w'>
                        <Col span={7} className='left'>Efficiency Per Seat No. of Total Restaurant 餐厅总餐位数坪效</Col>
                        <Col span={6} className='left'>  = 区域内 (BP 12.0 Cafe Budget/Forecast/Actual Revenue + BP 12.0 Chinese Resataurant Budget/Forecast/Actual Revenue + BP 12.0 Specia Restaurant Budget/Forecast/Actual Revenue + BP 12.0 Other Outlets Budget/Forecast/Actual Revenue + BP 12.0 Lobby Bar Budget/Forecast/Actual Revenue) 总和/(区域内 (BP 17.1 中餐厅餐位数 + BP 17.1 全日餐厅餐位数 + BP 17.1 大堂吧/酒吧餐位数 + BP 17.1 特色餐厅餐位数 + BP 17.1 其他餐厅A餐位数 + BP 17.1 其他餐厅B餐位数) 总和 * 当年天数)</Col>
                        <Col span={6} className='left'>  = 区间内 (BP 12.0 Cafe Budget/Forecast/Actual Revenue + BP 12.0 Chinese Resataurant Budget/Forecast/Actual Revenue + BP 12.0 Specia Restaurant Budget/Forecast/Actual Revenue + BP 12.0 Other Outlets Budget/Forecast/Actual Revenue + BP 12.0 Lobby Bar Budget/Forecast/Actual Revenue) 总和/(区间内 (BP 17.1 中餐厅餐位数 + BP 17.1 全日餐厅餐位数 + BP 17.1 大堂吧/酒吧餐位数 + BP 17.1 特色餐厅餐位数 + BP 17.1 其他餐厅A餐位数 + BP 17.1 其他餐厅B餐位数) 总和 * 当年天数)</Col>
                        <Col span={5}>  = (BP 12.0 Cafe Budget/Forecast/Actual Revenue + BP 12.0 Chinese Resataurant Budget/Forecast/Actual Revenue + BP 12.0 Specia Restaurant Budget/Forecast/Actual Revenue + BP 12.0 Other Outlets Budget/Forecast/Actual Revenue + BP 12.0 Lobby Bar Budget/Forecast/Actual Revenue)/((BP 17.1 中餐厅餐位数 + BP 17.1 全日餐厅餐位数 + BP 17.1 大堂吧/酒吧餐位数 + BP 17.1 特色餐厅餐位数 + BP 17.1 其他餐厅A餐位数 + BP 17.1 其他餐厅B餐位数) * 当年天数)</Col>
                    </Row>
                    <Row className='definition_bg_w'>
                        <Col span={7} className='left'>Efficiency Per Total Restaurant Space SQM 餐厅总面积坪效</Col>
                        <Col span={6} className='left'>  = 区域内 (BP 12.0 Cafe Budget/Forecast/Actual Revenue + BP 12.0 Chinese Resataurant Budget/Forecast/Actual Revenue + BP 12.0 Specia Restaurant Budget/Forecast/Actual Revenue + BP 12.0 Other Outlets Budget/Forecast/Actual Revenue + BP 12.0 Lobby Bar Budget/Forecast/Actual Revenue) 总和/(区域内 (BP 17.1 中餐厅面积 + BP 17.1 全日餐厅面积 + BP 17.1 大堂吧/酒吧面积 + BP 17.1 特色餐厅面积 + BP 17.1 其他餐厅A面积 + BP 17.1 其他餐厅B面积) 总和 * 当年天数)</Col>
                        <Col span={6} className='left'>  = 区间内 (BP 12.0 Cafe Budget/Forecast/Actual Revenue + BP 12.0 Chinese Resataurant Budget/Forecast/Actual Revenue + BP 12.0 Specia Restaurant Budget/Forecast/Actual Revenue + BP 12.0 Other Outlets Budget/Forecast/Actual Revenue + BP 12.0 Lobby Bar Budget/Forecast/Actual Revenue) 总和/(区间内 (BP 17.1 中餐厅面积 + BP 17.1 全日餐厅面积 + BP 17.1 大堂吧/酒吧面积 + BP 17.1 特色餐厅面积 + BP 17.1 其他餐厅A面积 + BP 17.1 其他餐厅B面积) 总和 * 当年天数)</Col>
                        <Col span={5}>  = (BP 12.0 Cafe Budget/Forecast/Actual Revenue + BP 12.0 Chinese Resataurant Budget/Forecast/Actual Revenue + BP 12.0 Specia Restaurant Budget/Forecast/Actual Revenue + BP 12.0 Other Outlets Budget/Forecast/Actual Revenue + BP 12.0 Lobby Bar Budget/Forecast/Actual Revenue) /((BP 17.1 中餐厅面积 + BP 17.1 全日餐厅面积 + BP 17.1 大堂吧/酒吧面积 + BP 17.1 特色餐厅面积 + BP 17.1 其他餐厅A面积 + BP 17.1 其他餐厅B面积) * 当年天数)</Col>
                    </Row>
                </div>
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/effect/description/index.js